import { Injectable } from '@angular/core';

import { AliasMap } from 'src/app/shared/constants/alias';

import { titleCase } from 'title-case';

@Injectable({
  providedIn: 'root',
})
export class HumanService {
  public fieldToTitle(field: string) {
    const partials = field.split('__');

    const clean_partials = partials.map((partial) => {
      const sub_partials = partial.split('_');

      const clean = sub_partials.map((sub_partial) => {
        return (
          AliasMap[sub_partial] ||
          sub_partial
        );
      });

      return clean.map(titleCase).join(' ');
    });

    return clean_partials.join(' ');
  }
}
